import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { RelatedServiceSetup } from "@apiModels/RelatedServiceSetup.csharp";

export const isRelatedServiceEnabled = (
  relatedServiceSetup: RelatedServiceSetup,
  location: LocationDto
) => {
  return (
    !relatedServiceSetup.disabledPlaces.includes(location.id) &&
    ((location.id && location.id != "-1") ||
      !relatedServiceSetup.doNotShowRsOptionWhenNoPlaceSelected)
  );
};

export const findRelatedServiceLocationSetup = (
  relatedServiceSetup: RelatedServiceSetup | undefined,
  location: LocationDto
) => {
  if (!relatedServiceSetup) {
    return undefined;
  }

  return relatedServiceSetup.locationSetups.find(
    (ls) =>
      ls.locationId === location.locationId || ls.locationId === location.id
  );
};

export const findRelatedSetupForAppointment = (
  relatedServiceSetups: RelatedServiceSetup[],
  appointment: AppointmentDto | undefined
) => {
  const relatedServiceSetup = relatedServiceSetups.find(
    (s) => s.relatedServiceId === appointment?.relatedServiceId
  );
  const relatedServiceLocationSetup = relatedServiceSetup?.locationSetups.find(
    (s) => s.locationId === appointment?.locationId
  );
  return {
    relatedServiceSetup,
    relatedServiceLocationSetup,
  };
};
